import { CP_CONTRACTOR_TYPES } from "@/static/cpContractorTypes";
import { FORM_OF_PAYMENTS } from "@/static/formOfPayments";
import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { CONTRACTOR_TYPE_TIN_ENUM } from "@/static/contractorTypeTINEnum";

export class ContractorSetting {
  @Expose()
  @IsOptional()
  @IsString()
  contractorOrderMonit!: string | null;

  @Expose()
  @IsOptional()
  @IsString()
  contractorBookingMonit!: string | null;

  @Expose()
  @IsOptional()
  @IsString()
  vindicationMonit!: string | null;

  @Expose()
  @IsBoolean()
  addNetAttributeToDescription!: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  documentLayout!: string | null;

  @Expose()
  @IsOptional()
  @IsString()
  printoutCulture!: string | null;

  @Expose()
  @IsNumber()
  debtLimit!: number;

  @Expose()
  @IsNumber()
  currentDebt!: number;

  @Expose()
  @IsBoolean()
  enabledDebtLimit!: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  formOfPaymentComment!: string | null;

  @Expose()
  @IsOptional()
  @IsEnum(FORM_OF_PAYMENTS)
  formOfPaymentId!: FORM_OF_PAYMENTS | null;

  @Expose()
  @IsNumber()
  invoiceCopyCount!: number;

  @Expose()
  @IsNumber()
  paymentDaysCount!: number;

  @Expose()
  comments: Record<string, string> = {};

  @Expose()
  @IsOptional()
  @IsString()
  defaultOrderCurrencyCode!: string | null;

  constructor() {
    this.contractorOrderMonit = null;
    this.contractorBookingMonit = null;
    this.vindicationMonit = null;
    this.addNetAttributeToDescription = false;
    this.documentLayout = null;
    this.printoutCulture = null;
    this.debtLimit = 0;
    this.currentDebt = 0;
    this.enabledDebtLimit = false;
    this.formOfPaymentComment = null;
    this.formOfPaymentId = FORM_OF_PAYMENTS.Cash;
    this.invoiceCopyCount = 0;
    this.paymentDaysCount = 0;
    this.defaultOrderCurrencyCode = null;
    this.comments = {};
  }
}

export class ContractorBasicInfoResponse {
  @Expose()
  @IsString()
  id!: string;

  @Expose()
  @IsNumber()
  @IsOptional()
  recipientStatusId!: number | null;

  @Expose()
  @IsString()
  name!: string;

  @Expose()
  @IsString()
  @IsOptional()
  surname!: null | string;

  @Expose()
  @IsString()
  shortName!: string;

  @Expose()
  @IsEnum(CONTRACTOR_TYPE_TIN_ENUM)
  countryTypeTIN!: CONTRACTOR_TYPE_TIN_ENUM;

  @Expose()
  @IsString()
  tin!: string;

  @Expose()
  @IsOptional()
  @IsString()
  nationalBusinessRegistryNumber!: string | null;

  @Expose()
  @IsString()
  city!: string;

  @Expose()
  @IsOptional()
  @IsString()
  country!: null | string;

  @Expose()
  @IsString()
  postalCode!: string;

  @Expose()
  @IsString()
  streetAndNumber!: string;

  @Expose()
  @IsOptional()
  @IsString()
  email!: string | null;

  @Expose()
  @IsOptional()
  @IsString()
  phoneNumber!: string | null;

  @Expose()
  @IsBoolean()
  isIndividual!: boolean;

  @Expose()
  @IsBoolean()
  isVatGroupMember!: boolean;

  @Expose()
  @IsBoolean()
  isLocalGovernmentUnit!: boolean;

  @Expose()
  @IsArray()
  @IsEnum(CP_CONTRACTOR_TYPES, { each: true })
  contractorTypes!: Array<CP_CONTRACTOR_TYPES>;

  @Expose()
  @IsArray()
  contractorCategories!: Array<number>;

  @Expose()
  @Type(() => ContractorSetting)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  contractorSetting!: ContractorSetting;

  constructor() {
    this.id = "";
    this.name = "";
    this.surname = "";
    this.shortName = "";
    this.countryTypeTIN = CONTRACTOR_TYPE_TIN_ENUM.PL;
    this.tin = "";
    this.nationalBusinessRegistryNumber = null;
    this.city = "";
    this.country = "";
    this.postalCode = "";
    this.streetAndNumber = "";
    this.email = null;
    this.phoneNumber = null;
    this.contractorTypes = new Array<CP_CONTRACTOR_TYPES>();
    this.contractorCategories = new Array<number>();
    this.contractorSetting = new ContractorSetting();
  }
}
